module.exports = __webpack_public_path__ + "img/title.52d623e5.svg";